import SystemInfo from "../";

const routes = [{ name: "SystemInfo", path: "/systeminfo", component: SystemInfo.SystemInfo, meta: { title: "System Info" } }];

export default routes;
